"use strict";Object.defineProperty(exports, "__esModule", {value: true});


 const selectPatientConversations = (state) => state.patientConversations; exports.selectPatientConversations = selectPatientConversations

 const selectPatientConversationMessages = (
  state,
  conversationKey,
) => state.patientConversationMessages[conversationKey]; exports.selectPatientConversationMessages = selectPatientConversationMessages
